import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface Equipment {
  id: string;
  en: string;
  de: string;
  location: {
    en: string;
    de: string;
  };
  status: 'operational' | 'faulty';
}

const equipmentList: Equipment[] = [
  {
    id: '103',
    en: 'Infusion Pump #103',
    de: 'Infusionspumpe #103',
    location: { en: 'Room 302', de: 'Zimmer 302' },
    status: 'operational',
  },
  {
    id: 'A22',
    en: 'Ventilator #A22',
    de: 'Beatmungsgerät #A22',
    location: { en: 'ICU Bay 4', de: 'ITS Bucht 4' },
    status: 'operational',
  },
  {
    id: 'D15',
    en: 'Defibrillator #D15',
    de: 'Defibrillator #D15',
    location: { en: 'Emergency Cart', de: 'Notfallwagen' },
    status: 'faulty',
  },
];

const generateEquipmentHtml = (language: 'en' | 'de'): string => {
  return `
    <div style="display: flex; flex-direction: column; height: 100%; font-family: 'Be Vietnam Pro', sans-serif; color: #282a32;">
      <div style="margin-bottom: 12px; font-weight: 600; color: #282a32;">
        ${language === 'en' ? 'Department Equipment' : 'Abteilungsgeräte'}
      </div>
      <div style="display: flex; flex-direction: column; gap: 10px;">
        ${equipmentList
          .map(
            equipment => `
            <div style="display: flex; justify-content: space-between; align-items: center; background-color: #fdfcff; padding: 12px; border-radius: 8px; border: 1px solid #eff1f6;">
              <div>
                <div style="font-weight: 500;">${equipment[language]}</div>
                <div style="font-size: 0.85rem; color: #686b87;">${equipment.location[language]}</div>
              </div>
              <div style="width: 40px; height: 24px; border-radius: 99em; background-color: #e9ecf4; position: relative;">
                <div style="position: absolute; left: 3px; top: 3px; height: 18px; width: 18px; background-color: ${equipment.status === 'operational' ? '#10b981' : '#ef4444'}; border-radius: 50%; ${equipment.status === 'operational' ? 'transform: translateX(16px);' : ''}"></div>
              </div>
            </div>`,
          )
          .join('')}
      </div>
    </div>`;
};

export const equipmentStatusWidget: MultilingualWidgetConfig = {
  id: 'equipment-status',
  translations: {
    en: {
      title: 'Equipment Status',
      content: generateEquipmentHtml('en'),
    },
    de: {
      title: 'Gerätestatus',
      content: generateEquipmentHtml('de'),
    },
  },
  x: 2,
  y: 6,
  w: 2,
  h: 3,
};
